import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { MaterialModule } from '../shared/material.module';
import { AddressEntryComponent } from './address-entry/address-entry.component';
import { AddressModalComponent } from './address-modal/address-modal.component';
import { AttachmentListComponent } from './attachment-list/attachment-list.component';
import { AttachmentModalComponent } from './attachment-modal/attachment-modal.component';
import { AttachmentsDragDropComponent } from './attachments-drag-drop/attachments-drag-drop.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { BarcodeTranslationModalComponent } from './barcode-translation-modal/barcode-translation-modal.component';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { CompleteRouteModalComponent } from './complete-route-modal/complete-route-modal.component';
import { CreditCardModalComponent } from './credit-card-modal/credit-card-modal.component';
import { DownloadFileComboButtonComponent } from './download-file-combo-button/download-file-combo-button.component';
import { DriverLocationModalComponent } from './driver-location-modal/driver-location-modal.component';
import { DriverLocationComponent } from './driver-location/driver-location.component';
import { DropPinModalComponent } from './drop-pin/drop-pin.modal';
import { EmailInputWithChipsComponent } from './email-input-with-chips/email-input-with-chips.component';
import { EmailInvoiceModalComponent } from './email-invoice-modal/email-invoice-modal.component';
import { EmailShippingLabelModalComponent } from './email-shipping-label-modal/email-shipping-label-modal.component';
import { EmailParcelDetailsModalComponent } from './email-parcel-details-modal/email-parcel-details-modal.component';
import { EmailRouteShippingLabelsModalComponent } from './email-route-shipping-labels-modal/email-route-shipping-labels-modal.component';
import { EmailRouteStopShippingLabelsModalComponent } from './email-route-stop-shipping-labels-modal/email-route-stop-shipping-labels-modal.component';
import { EmailParcelShippingLabelModalComponent } from './email-parcel-shipping-label-modal/email-parcel-shipping-label-modal.component';
import { PrintRouteTrackingShippingLabelModalComponent } from './print-route-tracking-shipping-label-modal/print-route-tracking-shipping-label-modal.component';
import { BasicEmailModalComponent } from './basic-email-modal/basic-email-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { FooterComponent } from './footer/footer.component';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { MfaChallengeComponent } from './mfa-challenge/mfa-challenge.component';
import { MfaEnrollmentWizardComponent } from './mfa-enrollment-wizard/mfa-enrollment-wizard.component';
import { MfaMethodDisabledComponent } from './mfa-method-disabled/mfa-method-disabled.component';
import { LogoSVGComponent } from './logo-svg/logo-svg.component';
import { MapComponent } from './map/map.component';
import { ModalComponent } from './modal/modal.component';
import { OrderTemplateModalComponent } from './order-template-modal/order-template-modal.component';
import { ParcelModalComponent } from './parcel-modal/parcel-modal.component';
import { ParcelsComponent } from './parcels/parcels.component';
import { PasswordResetModalComponent } from './password-reset-modal/password-reset-modal.component';
import { PersistInfoModalComponent } from './persist-info-modal/persist-info-modal.component';
import { PrintReceiptModalComponent } from './print-receipt-modal/print-receipt-modal.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { RecentOrdersModalComponent } from './recent-orders-modal/recent-orders-modal.component';
import { RecentTemplatesModalComponent } from './recent-templates-modal/recent-templates-modal.component';
import { SearchComponent } from './search/search.component';
import { SelectPrintLabelModalComponent } from './select-print-shipping-label/select-print-label-modal.component';
import { SessionWarningComponent } from './session-warning/session-warning.component';
import { SettlementDetailComponent } from './settlement-detail/settlement-detail.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SignatureModalComponent } from './signature-modal/signature.modal';
import { SpinnerComponent } from './spinner/spinner.component';
import { SubmittedOrdersModalComponent } from './submitted-orders-modal/submitted-orders-modal.component';
import { ToggleAllComponent } from './toggle-all/toggle-all.component';
import { TrackOrderDetailsModalComponent } from './track-order-details-modal/track-order-details-modal.component';
import { TrackParcelDetailsModalComponent } from './track-parcel-details-modal/track-parcel-details-modal.component';
import { TrackingProgressComponent } from './tracking-progress/tracking-progress.component';
import { WhatsNewModalComponent } from './whats-new-modal/whats-new-modal.component';
import { AlertComponent } from './alert/alert.component';
import { ParcelItemsComponent } from './parcel-items/parcel-items.component';
import { TypeaheadInfiniteScrollComponent } from './typeahead-infinite-scroll/typeahead-infinite-scroll.component';
import { ParcelsServerSideComponent } from './parcels-server-side/parcels-server-side.component';
import { LeafletMapComponent } from './leaflet-map/leaflet-map.component';
import { PrintReceiptComponent } from '../views/print-receipt/print-receipt.component';
import { PrintMultipleReceiptsComponent } from '../views/print-multiple-receipts/print-multiple-receipts.component';
import { RequiredDriverInputSectionComponent } from './required-driver-input-section/required-driver-input-section.component';

@NgModule({
	declarations: [
		AddressEntryComponent,
		AddressModalComponent,
		AttachmentListComponent,
		AttachmentModalComponent,
		AttachmentsDragDropComponent,
		BarcodeTranslationModalComponent,
		ChangePasswordModalComponent,
		CompleteRouteModalComponent,
		DriverLocationModalComponent,
		DropPinModalComponent,
		EmailInvoiceModalComponent,
		EmailShippingLabelModalComponent,
		EmailParcelDetailsModalComponent,
		EmailRouteShippingLabelsModalComponent,
		EmailRouteStopShippingLabelsModalComponent,
		EmailParcelShippingLabelModalComponent,
		PrintRouteTrackingShippingLabelModalComponent,
		BasicEmailModalComponent,
		ErrorModalComponent,
		LoginModalComponent,
		MfaChallengeComponent,
		MfaEnrollmentWizardComponent,
		MfaMethodDisabledComponent,
		LogoSVGComponent,
		MapComponent,
		ModalComponent,
		OrderTemplateModalComponent,
		FooterComponent,
		ParcelModalComponent,
		ParcelsComponent,
		PasswordResetModalComponent,
		PersistInfoModalComponent,
		PrintReceiptModalComponent,
		ReceiptComponent,
		RecentOrdersModalComponent,
		RecentTemplatesModalComponent,
		SelectPrintLabelModalComponent,
		SettlementDetailComponent,
		SidebarComponent,
		SignatureModalComponent,
		SubmittedOrdersModalComponent,
		TrackingProgressComponent,
		TrackOrderDetailsModalComponent,
		TrackParcelDetailsModalComponent,
		WhatsNewModalComponent,
		SearchComponent,
		SpinnerComponent,
		DownloadFileComboButtonComponent,
		AutocompleteComponent,
		EmailInputWithChipsComponent,
		ToggleAllComponent,
		SessionWarningComponent,
		DriverLocationComponent,
		CreditCardModalComponent,
		AlertComponent,
		ParcelItemsComponent,
		TypeaheadInfiniteScrollComponent,
		ParcelsServerSideComponent,
		LeafletMapComponent,
		PrintReceiptComponent,
		PrintMultipleReceiptsComponent,
		RequiredDriverInputSectionComponent
	],
	imports: [
		CommonModule,
		DirectivesModule,
		FormsModule,
		FlexLayoutModule,
		MaterialModule,
		NgxMaterialTimepickerModule,
		PipesModule,
		ReactiveFormsModule,
		RouterModule,
		TextMaskModule,
		TranslateModule,
		GoogleMapsModule
	],
	exports: [
		AddressEntryComponent,
		AttachmentListComponent,
		AttachmentsDragDropComponent,
		LogoSVGComponent,
		MapComponent,
		ModalComponent,
		NgxMaterialTimepickerModule,
		FooterComponent,
		ParcelsComponent,
		ReceiptComponent,
		SettlementDetailComponent,
		SidebarComponent,
		TrackingProgressComponent,
		SearchComponent,
		SpinnerComponent,
		AutocompleteComponent,
		ToggleAllComponent,
		EmailInputWithChipsComponent,
		AlertComponent,
		ParcelsServerSideComponent,
		LeafletMapComponent,
		PrintReceiptComponent,
		PrintMultipleReceiptsComponent,
		RequiredDriverInputSectionComponent
	]
})
export class ComponentsModule {
}
